import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';
import { LeadaComponentsModule } from 'shared/components';

import { AccountPage } from './components/account-page/account-page';
import { AddLeaderPage } from './components/add-leader-page/add-leader-page';
import {DevOptionsPage} from './components/dev-options-page/dev-options-page';
import {HelpPage} from './components/help-page/help-page';
import {PasswordSetPage} from './components/password-set-page/password-set-page';
import {ProfilePage} from './components/profile-page/profile-page';
import {SettingsPage} from './components/settings-page/settings-page';

import {UserRepository} from './repositories/user.repository';
import { UserService } from './services/user.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    RouterModule.forChild([
      { path: '', component: ProfilePage },
      { path: 'account', component: AccountPage },
      { path: 'help', component: HelpPage },
      { path: 'passwordset', component: PasswordSetPage },
      { path: 'settings', component: SettingsPage },
      { path: 'addleader', component: AddLeaderPage },
      { path: 'devoptions', component: DevOptionsPage },
    ]),
    LeadaComponentsModule,
  ],
  providers: [
    // UserRepository,
    // UserService,
  ],
  declarations: [
    DevOptionsPage,
    ProfilePage,
    PasswordSetPage,
    AccountPage,
    SettingsPage,
    AddLeaderPage,
    HelpPage,
  ],
  // entryComponents: [
  //   DevOptionsPage,
  //   ProfilePage,
  //   PasswordSetPage,
  //   SettingsPage,
  //   AccountPage,
  //   AddLeaderPage,
  //   HelpPage,
  // ],
})
export class ProfileModule { }
